import React from 'react';
import {
  initializeCollection,
  PagedCollectionProvider,
  usePagedCollectionDispatch,
  usePagedCollectionState,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const ManagedAccountAllocationHistoryContextProvider = ({
  link,
  ...rest
}) => {
  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: link,
      }}
      {...rest}
    />
  );
};

const initializeManagedAccountAllocationHistoryCollection = (dispatch, linkUrl) => {
  initializeCollection(dispatch, linkUrl);
};

const updateHistoryList = async (dispatch, collection) => {
  const latestCollection = await collection?.link('self').get();
  dispatch({ type: 'setCollection', collection: latestCollection });
};

const useManagedAccountAllocationHistoryDispatchContext = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useManagedAccountAllocationHistoryDispatchContext must be called from DispatchContext.Provider');

  return context;
};

const useManagedAccountAllocationHistoryStateContext = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useManagedAccountAllocationHistoryDispatchContext must be called from StateContext.Provider');

  return context;
};

export {
  ManagedAccountAllocationHistoryContextProvider,
  useManagedAccountAllocationHistoryDispatchContext,
  useManagedAccountAllocationHistoryStateContext,
  initializeManagedAccountAllocationHistoryCollection,
  updateHistoryList,
};
